export class ListData {
  pageIndex!: number;
  totalCount!: number;
  pageSize!: number;
  listReviews!: {
    reviewId: number,
    icon: string,
    name: string,
    reviewRate: number,
    reviewComment: string,
    reviewDateTime: string,
    canReport: boolean,
    reportStatus: ReportStatusEnum,
    reservationID: number
    isPostedanonymously: boolean
  }[];
  servicesReviewsTotal!: servicesReviews[];
  totalRateReview!: number;
  totalReviewsCount!: number;
}
export enum ReportStatusEnum {
  Reported = 'Reported',
  NotReported = 'NotReported',
  Resolved = 'Resolved'
}

export class TotalReviews {
  servicesReviewsTotal!: servicesReviews[];
  totalRateReview!: number;
  totalReviewsCount!: number;
}
export class ReviewsList {
  pageIndex!: number;
  pageSize!: number;
  totalCount!: number;
  listReviews!: {
    reviewId: number,
    icon: string,
    name: string,
    reviewRate: number,
    reviewComment: string,
    reviewDateTime: string,
    canReport: boolean,
    reportStatus: ReportStatusEnum,
    reservationID: number
    isPostedanonymously: boolean
  }[];
}

export class Record {
  reviewId!: number;
  reviewName!: string;
  reviewIcon!: string;
  reviewDate!: string;
  reviewRate!: number;
  reviewComment!: string;
  userType!: string;
  reservationNumber!: string;
  reservationID!: number;
  reservationId!: number;
  reviewPhotos!: string;
  brancheName!: string;
  reviewVideos!: [];
  orderedItems!: order[];
  amenities!: amenity[];
  canReport!: boolean;
  reportStatus!: ReportStatusEnum;
  isPostedanonymously!: boolean;
  reportDecision!: {
    decisionType: DecisionEnum
    resolution: string
    resolutionComment: string
    resolvedDate: string
    resolvedbyIcon: string
    resolvedbyName: string
  }[];
  reviewReport!: {
    reportComment: string
    reportDate: string
    reportNumber: string
    reportReasones: string
    reportedbyIcon: string
    reportedbyName: string
  };
}
export enum DecisionEnum {
  Hide = 'Hide',
  Keep = 'Keep'
}

export class amenity {
  amenitiesIcon!: string;
  amenitiesName!: string;
  amenitiesRate!: number;
  amenitiesRateType!: string;
}

export class order {
  orederItemIcon!: string;
  orderItemName!: string;
  orderItemRate!: number;
  orderItemRateType!: string;
}

export class ListFilter {
  pageSize!: number;
  pageNumber!: number;
  searchText!: string;
  reviewID!: number
  dateTo!: Date;
  dateFrom!: Date;
  rates!: number;
  resturantID!: number;
}

export class servicesReviews {
  serviceRateTotal!: number
  serviceNameTotal!: string
  serviceRateTypeTotal!: string
}
export enum reviewRate {
  All = 0,
  one = 1,
  Two = 2,
  Three = 3,
  Four = 4,
  Five = 5
}


export enum rateType {
  StarRating = 1,
  DashRating = 2,
}
